import { render, staticRenderFns } from "./RegisterResult.vue?vue&type=template&id=66686c82&scoped=true&"
import script from "./RegisterResult.vue?vue&type=script&lang=js&"
export * from "./RegisterResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66686c82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66686c82')) {
      api.createRecord('66686c82', component.options)
    } else {
      api.reload('66686c82', component.options)
    }
    module.hot.accept("./RegisterResult.vue?vue&type=template&id=66686c82&scoped=true&", function () {
      api.rerender('66686c82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/register/RegisterResult.vue"
export default component.exports